import { IEconomicsSettingsVariableAnnualInput } from '../../interfaces/ieconomics-settings-variable-annual-input';
import { EconomicsSetting } from '../economics-setting';

export class EconomicsSettingsVariableAnnualInputBase {
  EconomicsSettingsVariableAnnualInputId: number;
  EconomicsSettingId: number;
  Year: number | null;
  CommodityPriceOil: number | null;
  CommodityPriceNaturalGasLiquid: number | null;
  CommodityPriceGas: number | null;
  LeaseOperatingExpensePerBarrelOfOilEquivalent: number | null;
  LeaseOperatingExpensePerMonth: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  EconomicsSetting?: EconomicsSetting;

  constructor(item?: IEconomicsSettingsVariableAnnualInput) {
    if (item) {

      this.EconomicsSettingsVariableAnnualInputId = item.EconomicsSettingsVariableAnnualInputId;
      this.EconomicsSettingId = item.EconomicsSettingId;
      this.Year = item.Year;
      this.CommodityPriceOil = item.CommodityPriceOil;
      this.CommodityPriceNaturalGasLiquid = item.CommodityPriceNaturalGasLiquid;
      this.CommodityPriceGas = item.CommodityPriceGas;
      this.LeaseOperatingExpensePerBarrelOfOilEquivalent = item.LeaseOperatingExpensePerBarrelOfOilEquivalent;
      this.LeaseOperatingExpensePerMonth = item.LeaseOperatingExpensePerMonth;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.EconomicsSetting = new EconomicsSetting(item.EconomicsSetting);
    }
  }
}